import { render, staticRenderFns } from "./occurrence-category.vue?vue&type=template&id=1d006777&"
import script from "./occurrence-category.vue?vue&type=script&lang=js&"
export * from "./occurrence-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports